import seedPlaylistsData from './seedPlaylists.json';

// Track library with features (will be populated by analyzer later)
const tracks = [
  {
    id: 1,
    title: 'Café du Matin',
    artist: 'Melodiza AI',
    genre: 'jazz-swing',
    subgenre: 'Jazz Café',
    duration: 90,
    bpm: 95,
    energy: 35,
    key: 'Bb',
    camelot: '6A',
    brightness: 45,
    file: '/audio/jazz_cafe.mp3',
    cover:
      'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=300&h=300&fit=crop',
  },
  {
    id: 2,
    title: 'Dîner aux Chandelles',
    artist: 'Melodiza AI',
    genre: 'lounge',
    subgenre: 'Dîner Lounge',
    duration: 90,
    bpm: 78,
    energy: 25,
    key: 'Dm',
    camelot: '7A',
    brightness: 38,
    file: '/audio/lounge_dinner.mp3',
    cover:
      'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=300&h=300&fit=crop',
  },
  {
    id: 3,
    title: 'Bossa do Sol',
    artist: 'Melodiza AI',
    genre: 'bossa-nova',
    subgenre: 'Bossa Nova',
    duration: 90,
    bpm: 110,
    energy: 40,
    key: 'Am',
    camelot: '8A',
    brightness: 52,
    file: '/audio/bossa_nova.mp3',
    cover:
      'https://images.unsplash.com/photo-1572116469696-31de0f17cc34?w=300&h=300&fit=crop',
  },
  {
    id: 4,
    title: 'Zen Garden',
    artist: 'Melodiza AI',
    genre: 'ambient',
    subgenre: 'Ambient & Spa',
    duration: 90,
    bpm: 65,
    energy: 15,
    key: 'C',
    camelot: '8B',
    brightness: 28,
    file: '/audio/zen_spa.mp3',
    cover:
      'https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=300&h=300&fit=crop',
  },
  {
    id: 5,
    title: 'Soft Afternoon',
    artist: 'Melodiza AI',
    genre: 'chill',
    subgenre: 'Chill Downtempo',
    duration: 90,
    bpm: 78,
    energy: 30,
    key: 'G',
    camelot: '9B',
    brightness: 42,
    file: '/audio/chill_soft.mp3',
    cover:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=300&fit=crop',
  },
  {
    id: 6,
    title: 'Boutique Stroll',
    artist: 'Melodiza AI',
    genre: 'indie',
    subgenre: 'Indie Pop',
    duration: 90,
    bpm: 105,
    energy: 55,
    key: 'E',
    camelot: '12B',
    brightness: 62,
    file: '/audio/pop_shopping.mp3',
    cover:
      'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=300&h=300&fit=crop',
  },
  {
    id: 7,
    title: 'Grand Hotel',
    artist: 'Melodiza AI',
    genre: 'lounge',
    subgenre: 'Elegant Lounge',
    duration: 90,
    bpm: 72,
    energy: 28,
    key: 'F',
    camelot: '7B',
    brightness: 40,
    file: '/audio/elegant_lounge.mp3',
    cover:
      'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=300&h=300&fit=crop',
  },
  {
    id: 8,
    title: 'Power Pulse',
    artist: 'Melodiza AI',
    genre: 'edm',
    subgenre: 'Electronic Energy',
    duration: 90,
    bpm: 124,
    energy: 80,
    key: 'Am',
    camelot: '8A',
    brightness: 72,
    file: '/audio/electro_workout.mp3',
    cover:
      'https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=300&h=300&fit=crop',
  },
  {
    id: 9,
    title: 'Late Night Groove',
    artist: 'Melodiza AI',
    genre: 'deep-house',
    subgenre: 'Deep House',
    duration: 90,
    bpm: 118,
    energy: 55,
    key: 'Gm',
    camelot: '6A',
    brightness: 50,
    file: '/audio/deep_house.mp3',
    cover:
      'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=300&h=300&fit=crop',
  },
  {
    id: 10,
    title: 'Velvet Hours',
    artist: 'Melodiza AI',
    genre: 'rnb',
    subgenre: 'Smooth R&B',
    duration: 90,
    bpm: 88,
    energy: 50,
    key: 'Db',
    camelot: '12A',
    brightness: 55,
    file: '/audio/urban.mp3',
    cover:
      'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=300&h=300&fit=crop',
  },
  {
    id: 11,
    title: 'The Trip',
    artist: 'Still Corners',
    genre: 'indie',
    subgenre: 'Dream Pop',
    duration: 210,
    bpm: 100,
    energy: 45,
    key: 'A',
    camelot: '11B',
    brightness: 48,
    file: '/audio/the_trip.mp3',
    cover:
      'https://images.unsplash.com/photo-1494232410401-ad00d5433cfa?w=300&h=300&fit=crop',
  },
];

// 6 ambiances finales Melodiza (validées avril 2026)
const legacyPlaylists = [
  {
    id: 'morning-coffee',
    name: 'Morning Coffee',
    icon: '☕',
    description: 'Café spé, boulangerie, coworking & brunch',
    trackIds: [1, 3, 5],
    color: '#C28B5C',
    bpmRange: [70, 100],
    cover:
      'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=400&h=400&fit=crop',
    isDefault: true,
    genres: ['lounge', 'jazz-swing', 'chill'],
    businessTypes: ['restaurant', 'salon', 'office'],
    moods: ['chill', 'jazz', 'lounge'],
  },
  {
    id: 'soir-elegance',
    name: 'Soir Elegance',
    icon: '🍷',
    description: 'Resto chic, bistronomie, hôtel lux & bar à vin',
    trackIds: [2, 7, 5],
    color: '#4A0E4E',
    bpmRange: [60, 80],
    cover:
      'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=400&h=400&fit=crop',
    isDefault: true,
    genres: ['lounge', 'jazz-swing'],
    businessTypes: ['restaurant', 'hotel', 'bar'],
    moods: ['lounge', 'classical'],
  },
  {
    id: 'zen-wellness',
    name: 'Zen Wellness',
    icon: '🧘',
    description: 'Spa, yoga, pilates & instituts beauté',
    trackIds: [4, 5, 11],
    color: '#006D6F',
    bpmRange: [50, 75],
    cover:
      'https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=400&h=400&fit=crop',
    isDefault: true,
    genres: ['ambient', 'chill'],
    businessTypes: ['spa', 'salon', 'hotel'],
    moods: ['ambient', 'chill', 'classical'],
  },
  {
    id: 'modern-days',
    name: 'Modern Days',
    icon: '✨',
    description: 'Boutique hôtel, concept store, mode, coiffeurs',
    trackIds: [6, 11, 10],
    color: '#D17BB0',
    bpmRange: [90, 115],
    cover:
      'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=400&h=400&fit=crop',
    isDefault: true,
    genres: ['indie', 'chill'],
    businessTypes: ['boutique', 'salon', 'hotel', 'office'],
    moods: ['acoustic', 'pop'],
  },
  {
    id: 'cocktail-time',
    name: 'Cocktail Time',
    icon: '🍸',
    description: 'Terrasse, apéro, beach bar & rooftop',
    trackIds: [9, 5, 3],
    color: '#FF7F50',
    bpmRange: [95, 120],
    cover:
      'https://images.unsplash.com/photo-1551024601-bec78aea704b?w=400&h=400&fit=crop',
    isDefault: true,
    genres: ['edm', 'rnb', 'indie'],
    businessTypes: ['bar', 'restaurant'],
    moods: ['energetic', 'pop'],
  },
  {
    id: 'movement',
    name: 'Movement',
    icon: '⚡',
    description: 'Bar soirée, club lounge, gym & retail actif',
    trackIds: [8, 9, 10],
    color: '#FF4500',
    bpmRange: [110, 130],
    cover:
      'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=400&h=400&fit=crop',
    isDefault: true,
    genres: ['edm', 'deep-house'],
    businessTypes: ['gym', 'bar'],
    moods: ['energetic', 'electronic'],
  },
];

// 21 genres Melodiza
const genres = [
  { id: 'all', name: 'Tout', icon: '🎵' },
  { id: 'jazz-swing', name: 'Jazz & Swing', icon: '🎷' },
  { id: 'blues', name: 'Blues', icon: '🎸' },
  { id: 'lounge', name: 'Lounge', icon: '🍸' },
  { id: 'pop', name: 'Pop', icon: '✨' },
  { id: 'chill', name: 'Chill', icon: '🌿' },
  { id: 'ambient', name: 'Ambient', icon: '🌌' },
  { id: 'deep-house', name: 'Deep House', icon: '🎧' },
  { id: 'edm', name: 'EDM', icon: '⚡' },
  { id: 'rnb', name: 'R&B', icon: '💜' },
  { id: 'classical', name: 'Classique', icon: '🎻' },
  { id: 'bossa-nova', name: 'Bossa Nova', icon: '🌴' },
  { id: 'world', name: 'World', icon: '🌍' },
  { id: 'acoustic-folk', name: 'Acoustic Folk', icon: '🪕' },
  { id: 'soul-funk-disco', name: 'Soul Funk Disco', icon: '🕺' },
  { id: 'lofi', name: 'Lo-fi', icon: '🎚️' },
  { id: 'synthwave', name: 'Synthwave', icon: '🌃' },
  { id: 'kids', name: 'Kids', icon: '🧸' },
  { id: 'seasonal', name: 'Seasonal', icon: '🎄' },
  { id: 'indie', name: 'Indie', icon: '🎤' },
  { id: 'latin', name: 'Latin', icon: '🪘' },
  { id: 'afrobeats', name: 'Afrobeats', icon: '🥁' },
];

// playlists = legacy 6 + 30 seed = 36 total default catalog playlists
const playlists = [...legacyPlaylists, ...seedPlaylistsData];

export { tracks, playlists, genres };
